// Detectar se está rodando local ou em produção
const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
const API_BASE_URL = isLocal ? 'https://localhost:7058/api' : '/api'

export default {
  baseURL: API_BASE_URL,
  endpoints: {
    login: '/auth/login',
    listQuotes: '/vehicle-insurance/quotes/filter',
    quoteDetail: '/vehicle-insurance/quotes'
  }
}
